import { render, staticRenderFns } from "./NotificationButtonAdd.vue?vue&type=template&id=6d598484&scoped=true&"
import script from "./NotificationButtonAdd.vue?vue&type=script&lang=js&"
export * from "./NotificationButtonAdd.vue?vue&type=script&lang=js&"
import style0 from "./NotificationButtonAdd.vue?vue&type=style&index=0&id=6d598484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d598484",
  null
  
)

export default component.exports